import { Base } from "../core/base.model";

export class AutorizacionTiempoExtra extends Base {
  id: number;
  idUsuario: number;
  idLiderAutorizador: number;
  idProyecto: string;
  idTarea: number;
  fechaTrabajo: Date | string;
  minutosSolicitados: number;
  minutosAprobados: number;
  motivoEmpleado: string;
  comentarioLider: string;
  estatus: string;
  origenRegistro: string;
  fechaSolicitud: Date | string;
  fechaResolucion: Date | string;
  nombreUsuario: string;
  nombreLider: string;
  nombreProyecto: string;
  nombreTarea: string;
  minutosRegistradosDia: number;
  minutosObjetivoDia: number;
  minutosExcedentes: number;
}
